// extracted by mini-css-extract-plugin
export default {"Week":"URNnI","skeleton-progress":"_7ZpBn"};